module.exports = __webpack_public_path__ + "static/media/phone.111035a2.png";